var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/_core.js
// module id = 7
// module chunks = 0 1